module.exports = __webpack_public_path__ + "static/quality-e719ad4f1a74e3e67b35ef4673f8c133.jpg";